import styles from "./Fields.module.css";
import Stem from "../../assets/images/fields/Stem.png";
import Robotics from "../../assets/images/fields/Robotics.png";
import DroneTech from "../../assets/images/fields/DroneTech.png";
import Electronics from "../../assets/images/fields/Electronics.png";
import Coding from "../../assets/images/fields/Coding.png";
import SpaceTech from "../../assets/images/fields/SpaceTech.png";
import ArtificialIntelligence from "../../assets/images/fields/ArtificialIntelligence.png";
import ARVR from "../../assets/images/fields/ARVR.png";

const Offerings = () => {
  const offerings = [
    {
      icon: Stem,
      title: "STEM",
      subtitle: "Science, Technology, Engineering & Mathematics",
      description: "Comprehensive STEM education programs",
    },
    {
      icon: Robotics,
      title: "Robotics",
      subtitle: "Build, Program & Control Robots",
      description: "Hands-on robotics learning experience",
    },
    {
      icon: DroneTech,
      title: "Drone Tech",
      subtitle: "Aerial Technology & UAV Systems",
      description: "Learn drone programming and operations",
    },
    {
      icon: Electronics,
      title: "Electronics",
      subtitle: "Circuit Design & Microcontrollers",
      description: "Practical electronics and circuit building",
    },
    {
      icon: Coding,
      title: "Coding",
      subtitle: "Programming & Software Development",
      description: "Learn multiple programming languages",
    },
    {
      icon: SpaceTech,
      title: "Space Tech",
      subtitle: "Space Science & Technology",
      description: "Explore space technology and astronomy",
    },
    {
      icon: ArtificialIntelligence,
      title: "Artificial Intelligence",
      subtitle: "Machine Learning & Neural Networks",
      description: "Discover AI and its applications",
    },
    {
      icon: ARVR,
      title: "AR & VR",
      subtitle: "Augmented & Virtual Reality",
      description: "Create immersive digital experiences",
    },
  ];

  return (
    <section className={styles.offerings}>
      <div className={styles.container}>
        <h2 className={styles.title} data-aos="fade-up">
          We provide<span> STEMx programs</span> in schools
        </h2>
        <p className={styles.subtitle} data-aos="fade-up">
          With our comprehensive offerings, we focus on key areas such as AI,
          Coding, Robotics, STEM etc. Our goal is to equip young innovators with
          essential 21st-century skills, fostering creativity and
          problem-solving abilities that will help them thrive in a rapidly
          evolving technological landscape. increase width
        </p>

        <div className={styles.grid}>
          {offerings.map((offering, index) => (
            <div
              key={index}
              className={styles.card}
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className={styles.cardContent}>
                <div className={styles.imgWrapper}>
                  <img src={offering.icon} alt={offering.title} />
                </div>
                <div className={styles.cardText}>
                  <h3 className={styles.cardTitle}>{offering.title}</h3>
                  <h4 className={styles.cardSubtitle}>{offering.subtitle}</h4>
                </div>
              </div>
              <div
                className={styles.cardImage}
                style={{ backgroundImage: `url(${offering.image})` }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offerings;
